import PrintController from "./printController";
import { showPrintFailure } from "./printFailureNotice";

// BUG-2570: the bill is already saved when it is printed. A print that throws (bad till record,
// template code) must not fall into processOrder's catch, which treats the sale as failed; it is
// reported as a print failure and the sale finishes as normal.
const printSavedBill = (receipt, cartForLines) => {
  try {
    PrintController(receipt, cartForLines);
  } catch (error) {
    console.error("[BUG-2570] bill print threw after save", error);
    showPrintFailure({ kind: receipt?.draftFlag ? "draftBill" : "bill", ref: receipt?.documentno, cause: "unexpected", detail: error?.message });
  }
};

export default printSavedBill;
